export default "__VITE_ASSET__C899lrgF__"